var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdxTabVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 104,
    viewBox: "0 0 36 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.0059 82.7635C69.1223 82.7635 43.9989 93.4705 34.7977 98.824C27.3961 102.495 24.5129 97.2944 23.9965 94.2352C23.9965 68.5384 12.7948 44.5241 7.19397 35.7291C4.31359 30.2226 8.39414 26.5516 10.7945 25.4045C43.4388 23.569 65.2018 13.1679 72.0027 8.19683C80.6438 5.44359 83.6042 10.8736 84.0043 13.9327C84.9644 38.7118 96.406 64.0262 102.007 73.5861C104.887 80.0103 99.2063 82.3811 96.0059 82.7635Z",
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 6.97987
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0484 101.898C42.8626 83.287 19.054 73.0615 9.2979 70.275C1.90978 67.6083 3.83007 62.1314 5.71373 59.7262C24.3092 42.5263 34.5262 18.6979 37.3103 8.93373C39.4537 3.25401 44.7187 3.62173 47.0833 4.51555C69.28 25.8858 90.719 33.9898 98.6639 35.3705C106.18 39.5097 104.143 45.1936 102.185 47.5181C84.8679 64.7685 73.8633 89.6331 70.5258 99.9091C67.7182 106.203 62.3711 103.857 60.0484 101.898Z",
    stroke: "white",
    strokeOpacity: 0.09,
    strokeWidth: 6.97987
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdxTabVector);
export default __webpack_public_path__ + "static/media/ddx-tab-vector.0ee056f81fe0c1cb94a3bc2ef99e2083.svg";
export { ForwardRef as ReactComponent };